import { render, staticRenderFns } from "./Queue.vue?vue&type=template&id=7b7a3532&scoped=true&"
import script from "./Queue.vue?vue&type=script&lang=ts&"
export * from "./Queue.vue?vue&type=script&lang=ts&"
import style0 from "./Queue.vue?vue&type=style&index=0&id=7b7a3532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7a3532",
  null
  
)

export default component.exports